<div class="container" [dtWidthTrigger]="{ mobileLayout: 740 }" (dtWidthTriggerStateChange)="isMobileLayout = $event['mobileLayout']">
  <!-- Single header layout -->
  @if (!isMobileLayout && !isStartPage) {
    <div class="left-flex dt-dark-theme" [class.small]="!sidenavEnabled">
      <ng-container *ngTemplateOutlet="logoButton"></ng-container>
    </div>
  }
  @if (!isMobileLayout) {
    <div class="right-flex">
      <div class="dt-dark-theme theme-wrapper">
        <ng-container *ngTemplateOutlet="templateProjectsButton"></ng-container>
      </div>
      <div class="spacer"></div>
      @if (!isStartPage) {
        <dt-project-area></dt-project-area>
      }
      <div class="spacer"></div>
      <div class="dt-dark-theme theme-wrapper">
        <ng-container *ngTemplateOutlet="rightButtons"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="helpButton"></ng-container>
    </div>
  }

  <!-- Two header layout -->
  @if (isMobileLayout) {
    <div class="two-header-layout">
      <!-- top header line-->
      <div class="top-header dt-dark-theme">
        <ng-container *ngTemplateOutlet="templateProjectsButton"></ng-container>
        <div class="spacer"></div>
        @if (!isStartPage) {
          <div>
            <ng-container *ngTemplateOutlet="logoButton"></ng-container>
          </div>
        }
        <div class="spacer"></div>
        <ng-container *ngTemplateOutlet="rightButtons"></ng-container>
      </div>
      <!-- bottom header line -->
      @if (!isStartPage) {
        <mat-toolbar color="primary">
          <div class="flex-container">
            <div class="dt-dark-theme theme-wrapper">
              @if (sidenavEnabled) {
                <button mat-icon-button class="menu-button" (click)="hamburgerButtonClick.emit()">
                  <mat-icon>menu</mat-icon>
                </button>
              }
            </div>
            <div class="spacer"></div>
            <dt-project-area></dt-project-area>
            <div class="spacer"></div>
          </div>
          <ng-container *ngTemplateOutlet="helpButton"></ng-container>
        </mat-toolbar>
      }
    </div>
  }
</div>

<ng-template #userPopover let-close="close">
  @if (authService.user$ | async; as user) {
    <div class="user-popover mat-elevation-z3">
      <div class="user-info">
        <div>{{ user.name || user.email }}</div>
      </div>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="openAccountModal()" i18n>Profil</button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="openEventModal()" i18n>Veranstaltungen</button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="openInvitesModal()">
        <span [matBadge]="openInviteCount" matBadgeSize="small" matBadgeOverlap="false" [matBadgeHidden]="openInviteCount === 0" i18n
          >Einladungen</span
        ></button
      >
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="close(); logout()" i18n>Abmelden</button>
    </div>
  }
</ng-template>

<ng-template #updatePopover let-close="close">
  <div class="update-popover">
    <span i18n>Eine neue und verbesserte Version des Entscheidungsnavis ist jetzt verfügbar!</span>

    <button mat-raised-button color="accent" (click)="activateNaviUpdate()">
      <mat-icon>refresh</mat-icon>
      <span i18n>Jetzt aktualisieren</span>
    </button>

    <button mat-icon-button (click)="close()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #invitePopover let-close="close">
  <div class="update-popover">
    <span i18n>Du hast neue Einladungen erhalten!</span>

    <button mat-raised-button color="accent" (click)="openInvitesModal()">
      <mat-icon>view_list</mat-icon>
      <span i18n>Einladungen anzeigen</span>
    </button>

    <button mat-icon-button (click)="close(); this.hideInvitePopover = true" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #logoButton>
  <button mat-button data-cy="mode-switch-button" class="change-mode-button" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
    <div class="content">
      <div class="logo">
        <span>ENTSCHEIDUNGSNAVI</span>
        <div class="project-mode">
          <span>{{ decisionData.projectMode | titlecase }}</span>
        </div>
      </div>
      <mat-icon>{{ menuTrigger.menuOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
    </div>
  </button>
  <mat-menu #menu="matMenu" xPosition="before">
    <div data-cy="mode-switch-menu">
      <mat-radio-group [value]="decisionData.projectMode" class="menu">
        <mat-radio-button [value]="'starter'" *dtProjectMode="'starter'">Starter</mat-radio-button>
        <mat-radio-button [value]="'educational'" (click)="switchMode('educational'); $event.preventDefault()"
          >Educational</mat-radio-button
        >
        <mat-radio-button [value]="'professional'" (click)="switchMode('professional'); $event.preventDefault()"
          >Professional</mat-radio-button
        >
      </mat-radio-group>
    </div>
  </mat-menu>
</ng-template>

<ng-template #templateProjectsButton>
  @if (projectService.getProjectType() !== 'embedded') {
    <button data-cy="project_mgmt" class="template-projects-button" (click)="openProjectModal()" mat-button>
      <span i18n>Projekte</span>
    </button>
  }
</ng-template>

<ng-template #rightButtons>
  @if (projectService.getProjectType() !== 'embedded') {
    <button
      mat-button
      #updateButton
      [class.invisible]="!isUpdateAvailable"
      (click)="toggleUpdatePopover()"
      class="update-button"
      i18n-matTooltip
      matTooltip="Update verfügbar"
      matTooltipShowDelay="1000"
      i18n
      >Neue Version verfügbar!</button
    >
    @switch (authService.loggedIn$ | async) {
      @case (false) {
        <div class="login-button-wrapper">
          <button (click)="openLoginModal()" mat-raised-button color="accent" #loginButton i18n>Anmelden</button>
        </div>
      }
      @case (true) {
        <button
          mat-icon-button
          #userButton
          i18n-matTooltip
          matTooltip="Profil"
          matTooltipShowDelay="1000"
          (click)="openUserPopover(userPopover)"
          data-cy="user-button"
        >
          <span [matBadge]="openInviteCount" matBadgeSize="small" [matBadgeHidden]="openInviteCount === 0"
            ><mat-icon>person</mat-icon></span
          >
        </button>
      }
      <!-- Show a spinner when we are loading (the async pipe returns undefined) -->
      @default {
        <div class="login-spinner-wrapper">
          <mat-spinner color="accent" [diameter]="24"></mat-spinner>
        </div>
      }
    }
    <button mat-icon-button (click)="openAppSettings()" matTooltip="Navi-Einstellungen" i18n-matTooltip matTooltipShowDelay="500">
      <mat-icon>settings</mat-icon>
    </button>
    <button
      mat-icon-button
      [matMenuTriggerFor]="languageMenu"
      i18n-matTooltip
      matTooltip="Sprache"
      matTooltipShowDelay="1000"
      class="language-button"
    >
      <mat-menu #languageMenu>
        <mat-radio-group class="menu" [value]="language">
          <mat-radio-button value="de" (click)="$event.preventDefault(); changeLanguage('de')"> Deutsch</mat-radio-button>
          <mat-radio-button value="en" (click)="$event.preventDefault(); changeLanguage('en')"> English</mat-radio-button>
        </mat-radio-group>
      </mat-menu>
      @switch (language) {
        @case ('en') {
          EN
        }
        @case ('de') {
          DE
        }
      }
    </button>
  }
</ng-template>

<ng-template #helpButton>
  @if ((sideBySideService.state === 'history' || decisionData.isEducational()) && !isStartPage) {
    <button
      class="side-by-side-button"
      mat-icon-button
      (click)="toggleHelpAssistant()"
      [class.history-button]="sideBySideService.state === 'history'"
      data-cy="toggle-help-button"
    >
      <mat-icon>{{ sideBySideService.state !== 'closed' ? 'close' : 'help' }}</mat-icon>
    </button>
  }
</ng-template>
